import styled, { keyframes } from "styled-components";


export const MainContainer = styled.div`
  width: 80%;
  margin: 3rem 11rem;

  // @media (min-width: 576px) {
  //   max-width: 540px;
  // }
  // @media (min-width: 768px) {
  //   max-width: 720px;
  // }
  // @media (min-width: 992px) {
  //   max-width: 960px;
  // }
  // @media (min-width: 1200px) {
  //   max-width: 1000px;
  // }
`;